import React, { useEffect, useState } from 'react';
import { IoChatbubbleEllipsesOutline } from 'react-icons/io5';
import { NavLink } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import { addMenu } from '../../redux/slices/menu';
import { Badge } from 'antd';
import { useTranslation } from 'react-i18next';
import { ADMIN_CHAT_COUNTS_EVENT } from '../../components/admin-chat-watch';

/**
 * The header's chat button, with a count of threads waiting on a reply.
 *
 * The count is read from what AdminChatWatch publishes rather than fetched.
 * This used to dispatch `fetchConversations()` on mount — every thread and its
 * last message, from Firestore, on every dashboard load — to add up a number
 * the watcher already had. Two components asking the same expensive question
 * is how the day's read allowance went, and when it ran out this was also the
 * request whose failure raised a toast on whatever page the shop was working
 * on.
 *
 * It now shows the same figure as the sidebar's Chat badge, which is the one
 * people were comparing it against anyway.
 */
const ChatIcons = () => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const goToChat = () => {
    dispatch(
      addMenu({
        url: 'chat',
        id: 'chat',
        name: t('chat'),
      }),
    );
  };

  const [waiting, setWaiting] = useState(
    () => window.__ksAdminChatCounts?.waiting || 0,
  );

  useEffect(() => {
    const handler = (e) => setWaiting(e?.detail?.waiting || 0);
    window.addEventListener(ADMIN_CHAT_COUNTS_EVENT, handler);
    return () => window.removeEventListener(ADMIN_CHAT_COUNTS_EVENT, handler);
  }, []);

  return (
    <NavLink onClick={goToChat} to='/chat' className='chat'>
      <Badge count={waiting}>
        <IoChatbubbleEllipsesOutline className='chat-icon' />
      </Badge>
    </NavLink>
  );
};

export default ChatIcons;
